import { useRef, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import SectionTitle from '../SectionTitle/SectionTitle'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './GallerySection.module.scss'

const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function GallerySection() {
    const swiperRef = useRef(null)
    const prevRef = useRef(null)
    const nextRef = useRef(null)

    const [photos, setPhotos] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        fetch(`${API_PREFIX}/api/sections/get/photos/list`)
            .then((res) => {
                if (!res.ok) throw new Error('Ошибка загрузки галереи')
                return res.json()
            })
            .then((data) => {
                setPhotos(data.photos ?? [])
                setLoading(false)
            })
            .catch((e) => {
                setError(e.message)
                setLoading(false)
            })
    }, [])

    const isTouchDevice = () =>
        'ontouchstart' in window || navigator.maxTouchPoints > 0

    const handleButtonEffect = (e) => {
        if (!e.currentTarget) return
        e.currentTarget.classList.add(styles.active)
        setTimeout(() => {
            if (e.currentTarget) {
                e.currentTarget.classList.remove(styles.active)
            }
        }, 300)
    }

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            const swiper = swiperRef.current.swiper
            swiper.params.navigation.prevEl = prevRef.current
            swiper.params.navigation.nextEl = nextRef.current
            swiper.navigation.destroy()
            swiper.navigation.init()
            swiper.navigation.update()
        }
    }, [photos])

    return (
        <section className={styles.gallery}>
            <div className={styles.galleryContainer}>
                <SectionTitle>Галерея наших занятий</SectionTitle>

                {loading && <div>Загрузка...</div>}
                {error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}

                {!loading && !error && (
                    <Swiper
                        ref={swiperRef}
                        modules={[Navigation]}
                        loop={true}
                        spaceBetween={40}
                        slidesPerView={2} /* По умолчанию показываем 2 фото */
                        grabCursor={true}
                        navigation={{
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        }}
                        breakpoints={{
                            /* На телефонах 1 фото, на планшетах и ПК - 2 больших фото */
                            320: { slidesPerView: 1, spaceBetween: 20 },
                            768: { slidesPerView: 2, spaceBetween: 40 },
                        }}
                        onSwiper={(swiper) => {
                            swiper.params.navigation.prevEl = prevRef.current
                            swiper.params.navigation.nextEl = nextRef.current
                            swiper.navigation.init()
                            swiper.navigation.update()
                        }}
                    >
                        {photos.map((src, i) => (
                            <SwiperSlide key={i}>
                                <div className={styles.photoCard}>
                                    <img
                                        src={src.startsWith('/') ? API_PREFIX + src : src}
                                        alt={`Фото ${i + 1}`}
                                        loading='lazy'
                                        className={styles.photo}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}

                <div className={styles.galleryNavigation}>
                    <div
                        className={styles.gallerySliderButtonPrev}
                        ref={prevRef}
                        onClick={() => swiperRef.current?.swiper.slidePrev()}
                    >
                        <div
                            className={styles.btnContainer}
                            {...(isTouchDevice()
                                ? { onTouchStart: handleButtonEffect }
                                : { onMouseDown: handleButtonEffect })}
                        >
                            <div className={styles.consultBtn}>
                                <img src='/img/slider/arrow-left.svg' alt='Prev' />
                            </div>
                        </div>
                    </div>

                    <div
                        className={styles.gallerySliderButtonNext}
                        ref={nextRef}
                        onClick={() => swiperRef.current?.swiper.slideNext()}
                    >
                        <div
                            className={styles.btnContainer}
                            {...(isTouchDevice()
                                ? { onTouchStart: handleButtonEffect }
                                : { onMouseDown: handleButtonEffect })}
                        >
                            <div className={styles.consultBtn}>
                                <img src='/img/slider/arrow-right.svg' alt='Next' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
